import { motion } from "framer-motion";
import { Zap, BadgeCheck, Users, MapPin, Home, Banknote } from "lucide-react";

const REASONS = [
  { icon: Zap, title: "Fast Turnaround", desc: "We show up when we say we will and get the structure up without the run-around." },
  { icon: BadgeCheck, title: "Quality Workmanship", desc: "Every cut, joint and fixing done properly the first time. No shortcuts, ever." },
  { icon: Users, title: "Experienced Team", desc: "Seasoned roof carpenters who've framed everything from granny flats to full custom builds." },
  { icon: MapPin, title: "Perth-Wide", desc: "From Two Rocks to Mandurah and out to the hills — if it's in the metro, we're there." },
  { icon: Home, title: "Residential & Construction", desc: "Owner-builders, renovators and volume builders alike. Residential and site work covered." },
  { icon: Banknote, title: "No Upfront Payment", desc: "You don't pay a cent until the work is done and you're happy with it." },
];

const reveal = {
  hidden: { opacity: 0, y: 30 },
  visible: (i) => ({
    opacity: 1,
    y: 0,
    transition: { delay: i * 0.08, duration: 0.6, ease: [0.16, 1, 0.3, 1] },
  }),
};

export default function WhyUs() {
  return (
    <section id="why-us" data-testid="why-us-section" className="border-b border-neutral-800 bg-surface">
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-24 md:py-32">
        <motion.div
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, margin: "-80px" }}
          variants={reveal}
          custom={0}
          className="mb-16"
        >
          <p className="text-sm uppercase tracking-[0.3em] text-timber mb-4">Why A E Carpentry</p>
          <h2 className="font-display font-bold uppercase tracking-tight text-4xl md:text-5xl lg:text-6xl text-white leading-[0.9]">
            Built on reputation.<br />
            <span className="text-outline">Kept by results.</span>
          </h2>
        </motion.div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 border-t border-l border-neutral-800">
          {REASONS.map((r, i) => (
            <motion.div
              key={r.title}
              data-testid={`why-us-item-${i + 1}`}
              initial="hidden"
              whileInView="visible"
              viewport={{ once: true, margin: "-40px" }}
              variants={reveal}
              custom={i + 1}
              className="group border-r border-b border-neutral-800 p-8 md:p-10 hover:bg-obsidian transition-colors duration-300"
            >
              <r.icon size={28} className="text-timber mb-6" strokeWidth={1.5} />
              <h3 className="font-display font-semibold uppercase tracking-wide text-lg md:text-xl text-white">
                {r.title}
              </h3>
              <p className="text-neutral-400 text-sm md:text-base leading-relaxed mt-3">{r.desc}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
